export const Global = {
    domain: 'jurispol'
};
